import { Header } from '../BaseTabsRouting/types';
import { getViewsByParent } from '../BaseTabsRouting/utils';
import { AdminTableMenusOptions } from './adminTableMenusOptions.enum';
import { adminTableViews } from './adminTableViews.const';

export const adminTableHeaders: Header[] = [
  {
    subHeaderName: AdminTableMenusOptions.SETTINGS,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.SETTINGS
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.YEAR,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.YEAR
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.TRAVEL_COST,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.TRAVEL_COST
    ),
    requiredGrants: ['hasTravelCostCalculationAccess']
  },
  {
    subHeaderName: AdminTableMenusOptions.EMPLOYER,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.EMPLOYER
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.POOLS,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.POOLS
    ),
    requiredGrants: ['hasPoolsOrgGrant']
  },
  {
    subHeaderName: AdminTableMenusOptions.CLA,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.CLA
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.MRP,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.MRP
    ),
    requiredGrants: ['hasMultiResourcePlanningModule']
  }
];
